import React from 'react';
import v from 'vudu';
import Tick from './svgs/Tick';
import { styles as s, colors } from 'stylesheet';

const OPTION_INPUT_SIZE = 18;
const WAVE_SIZE = 200;

const localClasses = v({
  optionInput: {
    appearance: 'none',
    position: 'relative',
    top: '4px',
    right: 0,
    bottom: 0,
    left: 0,
    height: `${OPTION_INPUT_SIZE}px`,
    width: `${OPTION_INPUT_SIZE}px`,
    transition: 'all 150ms ease-out',
    background: 'transparent',
    border: '1.5px solid grey',
    cursor: 'pointer',
    display: 'inline-block',
    marginRight: '0.5rem',
    outline: 'none',
    zIndex: 1,
    borderRadius: '50%',
    opacity: 0.4,
    ':hover': {
      border: '1.5px solid white',
      '+ svg': { opacity: 0.4 }
    },
    ':checked': {
      opacity: 1,
      '+ svg': { opacity: 1 },
      background: colors.razzmatazz,
      border: `1.5px solid ${colors.razzmatazz}`,
      '::after': {
        animation: 'clickWave 0.65s',
        background: `${colors.razzmatazz}`,
        content: '""',
        display: 'block',
        position: 'relative',
        zIndex: 2
      }
    },
    '::after': {
      borderRadius: '50%'
    },
    '@keyframes clickWave': {
      '0%': {
        height: `${OPTION_INPUT_SIZE}px`,
        width: `${OPTION_INPUT_SIZE}px`,
        opacity: 0.45,
        position: 'relative',
      },
      '100%': {
        height: `${WAVE_SIZE}px`,
        width: `${WAVE_SIZE}px`,
        marginLeft: `-${(WAVE_SIZE/2) - (OPTION_INPUT_SIZE/2)}px`,
        marginTop: `-${(WAVE_SIZE/2) - (OPTION_INPUT_SIZE/2)}px`,
        opacity: 0
      }
    }
  },
  tooltipVariant: {
    color: 'black !important',
    'a': {
      color: 'black',
      borderBottom: '1px solid black'
    }
  },
  optionInputLabel: {
    '@composes': [s.relative, s.white],
    fontSize: '12px',
    'svg': {
      transition: 'all 150ms ease-out',
      position: 'absolute',
      opacity: 0,
      top: '2px',
      left: '5px',
      zIndex: 3,
    },
  },
});

export default props => {
  let wrapper = localClasses.optionInputLabel;
  if (props.renderAsTooltip) wrapper += ` ${localClasses.tooltipVariant}`;
  return (
    <label className={wrapper}>
      <input
        type="checkbox"
        className={localClasses.optionInput}
        checked={props.checked}
        onClick={props.onClick}
      />
      <Tick className={localClasses.tick} />
      {props.children}
    </label>
  )
};



// WEBPACK FOOTER //
// ./src/components/OptionInput.js